module.exports = __webpack_public_path__ + "img/plane.b9adead9.png";